import { TransactionSupportComingSoonPanel } from '@/components/common/transactionSupportComingSoonPanel'

interface Props {
  className?: string
}

export const BorrowMarketTxNotSupportedPanel = ({ className }: Props) => (
  <TransactionSupportComingSoonPanel
    description="Borrow transactions are coming soon. Track rates and explore markets in read-only mode now."
    className={className}
  />
)
